<div id="budgetUploadTemplate" class="grid min-h-[360px] max-w-3xl grid-cols-2 gap-5 px-[5px]">
  <div>
    @if (ref.data?.isMultiple) {
      <div class="mb-1 text-xs">Vendor Contract(s)</div>
      <aux-multiple-vendor-select
        [(appliedSelectedVendorIDs)]="selectedVendorIDs"
        placeholder="Select"
        [isRequired]="false"
        class="mb-3 block w-[320px]"
      />
    } @else {
      <div class="mb-4">
        <div class="mb-1 text-xs">
          Vendor Contract
          <span class="font-bold text-aux-error">*</span>
        </div>
        <ng-select
          placeholder="Select"
          id="vendors"
          [formControl]="selectedVendor"
          [appendTo]="'body'"
          [searchable]="true"
          [clearable]="false"
          (change)="onVendorSelected($event)"
        >
          @for (vendor of vendors(); track vendor) {
            <ng-option [value]="vendor">
              <span [title]="vendor.name">{{ vendor.name }}</span>
            </ng-option>
          }
        </ng-select>
      </div>
    }
    <div class="mb-3">
      <aux-input
        class="budgetVersionInput"
        label="Budget Version"
        validators="required"
        [showRequiredAsterisk]="true"
        [formControl]="budget_version"
      />
    </div>

    <div class="mb-4">
      <div class="flex items-center">
        <span class="block text-sm font-medium text-gray-700">Budget Upload</span>
      </div>

      <div class="ml-4 mt-2 flex space-x-4 text-xs">
        <div class="flex items-center">
          <input
            name="template_type"
            type="radio"
            value="budget"
            class="h-3 w-3 border-gray-300 text-indigo-600 focus:ring-indigo-500"
            [id]="'template_budget'"
            [formControl]="selectedTemplate"
          />
          <label class="ml-2" [for]="'template_budget'">
            <span class="block text-sm font-medium text-gray-700">Forecast/Logic</span>
          </label>
        </div>
        <div class="flex items-center">
          <input
            name="template_type"
            type="radio"
            value="forecast"
            class="h-3 w-3 border-gray-300 text-indigo-600 focus:ring-indigo-500"
            [id]="'template_forecast'"
            [formControl]="selectedTemplate"
          />
          <label class="ml-2" [for]="'template_forecast'">
            <span class="block text-sm font-medium text-gray-700">Manual/Custom</span>
          </label>
        </div>
      </div>
    </div>

    @if (!ref.data?.isMultiple) {
      <div>
        <div class="mt-3 flex items-center">
          <input
            name="budget_type"
            type="radio"
            value="secondary"
            class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
            [id]="'budget_secondary'"
            [formControl]="selectedBudgetType"
          />
          <label class="ml-2" [for]="'budget_secondary'">
            <span class="block text-sm font-medium text-gray-700">
              Scenario Budget (e.g. Vendor Contract forecast)
            </span>
          </label>
        </div>
      </div>
    }

    <div class="mt-3">
      <aux-checkbox
        class="text-sm font-medium"
        [id]="'bypass-validation'"
        [(ngModel)]="bypassValidation"
      >
        Bypass blank Activity ID check
      </aux-checkbox>
    </div>

    <div class="mt-3">
      <aux-checkbox
        class="text-sm font-medium"
        [id]="'attributes-override'"
        [(ngModel)]="attributesOverride"
      >
        I am overriding existing attributes
      </aux-checkbox>
    </div>

    @if (!ref.data?.isMultiple) {
      <div class="mt-3">
        <h2>Budget Validation</h2>
        <div class="grid grid-cols-2 gap-x-1">
          <div>
            <div class="input-icon">
              <aux-input
                class="border-none pl-3 pt-2"
                placeholder="Budget Total"
                label="Budget Total"
                [(ngModel)]="budgetTotal"
              />
              <i class="ml-1 text-sm italic text-aux-gray-dark">$</i>
            </div>
            @if (isBudgetTotalInvalid()) {
              <span class="text-sm text-aux-error">
                Can only be a number with up to two decimal places
              </span>
            }
          </div>
          <div>
            <div class="input-icon">
              <aux-input
                class="border-none pl-3 pt-2"
                label="Services Total"
                [(ngModel)]="servicesTotal"
              />
              <i class="ml-1 text-sm italic text-aux-gray-dark">$</i>
            </div>
            @if (isServiceTotalInvalid()) {
              <span class="text-sm text-aux-error">
                Can only be a number with up to two decimal places
              </span>
            }
          </div>
          <div>
            <div class="input-icon">
              <aux-input
                class="border-none pl-3 pt-2"
                label="Discount Total"
                [(ngModel)]="discountTotal"
                (ngModelChange)="onDiscountTotalChange()"
              />
              <i class="ml-1 text-sm italic text-aux-gray-dark">$</i>
            </div>
            @if (isDiscountTotalInvalid()) {
              <span class="text-sm text-aux-error">
                Can only be a number with up to two decimal places
              </span>
            }
          </div>
          <div>
            <div class="input-icon">
              <aux-input
                class="border-none pl-3 pt-2"
                label="Pass-through Total"
                [(ngModel)]="passthroughTotal"
              />
              <i class="ml-1 text-sm italic text-aux-gray-dark">$</i>
            </div>
            @if (isPassthroughTotalInvalid()) {
              <span class="text-sm text-aux-error">
                Can only be a number with up to two decimal places
              </span>
            }
          </div>
          <div>
            <div class="input-icon">
              <aux-input
                class="border-none pl-3 pt-2"
                label="Investigator Total"
                [(ngModel)]="investigatorTotal"
              />
              <i class="ml-1 text-sm italic text-aux-gray-dark">$</i>
            </div>
            @if (isInvestigatorTotalInvalid()) {
              <span class="text-sm text-aux-error">
                Can only be a number with up to two decimal places
              </span>
            }
          </div>
          <div>
            <aux-input
              class="border-none pl-3 pt-2"
              label="Services Categories"
              [(ngModel)]="servicesCategories"
            />
            @if (isServicesCategoriesInvalid()) {
              <span class="text-sm text-aux-error">Must be whole number greater than 0</span>
            }
          </div>
          <div>
            <aux-input
              class="mb-0.5 border-none pl-3 pt-2"
              label="Budget Lines"
              [(ngModel)]="budgetLines"
            />
            @if (isBudgetLinesInvalid()) {
              <span class="text-sm text-aux-error">Must be whole number greater than 0</span>
            }
          </div>
        </div>
      </div>
    }

    @if (errorMessage()) {
      <div class="mt-3 rounded-md bg-aux-error p-5 font-medium text-white">
        {{ errorMessage() }}
      </div>
    }
  </div>
  <div>
    @if (ref.data?.isMultiple) {
      <aux-download-template-button
        [templateType]="templateTypes.MULTI_VENDOR_BUDGET_TEMPLATE"
        label="Download the template"
        [showIcon]="false"
        [vendorId]="null"
        [templatePayload]="{ vendor_ids: selectedVendorIDs() }"
        [fileName]="(budgetTemplateFileName$ | async)!"
        class="mb-4 flex justify-center"
      />
    } @else {
      <aux-download-template-button
        [templateType]="templateTypes.VENDOR_BUDGET_TEMPLATE"
        label="Download the template"
        [showIcon]="false"
        [vendorId]="selectedVendor.value?.id"
        [fileName]="(budgetTemplateFileName$ | async)!"
        class="mb-4 flex justify-center"
      />
    }

    <div
      class="btn--hyperlink mb-4 flex cursor-pointer justify-center"
      (click)="downloadInstructions()"
    >
      Vendor Budget Template Instructions
    </div>

    <aux-file-manager
      #manager
      class="h-48"
      [fetchFilesOnInit]="false"
      [pathFn]="pathFn"
      [eager]="false"
      [metadata]="metadata"
      [showSuccessOnUpload]="true"
      [accept]="'.csv'"
    />
    <div class="mt-3 max-h-60 overflow-auto">
      <aux-file-viewer
        [fileManager]="manager"
        [disableFirstFileMargin]="true"
        [onlyShowUploaded]="false"
      />
    </div>
  </div>
</div>
